// extracted by mini-css-extract-plugin
export default {"meal":"MealsItem_meal__TYj9A","description":"MealsItem_description__z6XFH","price":"MealsItem_price__QjyJW"};